<template>
    <fieldset>
        <div class="form-group">
            <label class="control-label">Company</label>
            <company v-model="model.company"></company>
        </div>
        <txt label="Domain Name" v-model="model.domain"></txt>
        <list id="server_id" label="Server Type" :list='["Office 365", "External"]' v-model="model.server_type"></list>
        <!--<domain-ls></domain-ls>-->
        <div class="buttons">
            <button @click.prevent="store" type="submit" class="btn btn-success btn-sm">Save</button>
        </div>
    </fieldset>
</template>

<script>
    export default {
        props: {
            name: { default: '' },
        },
        data: function() {
            return {
                model: {
                    company: {},
                    domain: '',
                    server_type: ''
                }
            }
        },
        created() {
            this.$eventHub.$on('setEmailaccount', this.setEmailaccount);
        },
        components: {
            'domain-ls': require('../../components/domain-ls.vue').default
        },
        methods: {
            store(){
                this.model.closeDialog = true;
                this.$eventHub.$emit('latest-notif', {
                    title: 'Email Account being deployed',
                    timeout: true
                });
                this.$store('/api/email/account/store', this);
            },
            setEmailaccount(data) {
                let vm = this;
                $.each(this.model, function (key, value) {
                    let val = '';
                    if (typeof data[key] !== 'undefined') {
                        val = data[key];
                    }
                    vm.model[key] = val;
                });
            },
        },
        // It's good to clean up event listeners before a component is destroyed.
        beforeDestroy () {
            this.$eventHub.$off('setEmailaccount', this.setEmailaccount);
        }
    }
</script>
